import React, {useState} from 'react'
import {makeStyles} from '@mui/styles';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import {AccessTime, BookmarkBorder, ChatBubbleOutline, FavoriteBorder, Kitchen, Visibility} from '@mui/icons-material';
import {Button, CardHeader, Chip, Icon} from '@mui/material';
import Ingredient from '../../../Ingredients/Ingredient'
import MenuIcon from '../../../../Toolbar/Menu/CardMenu';

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    card: {
        maxWidth: 450,
        width: "100%",
        minWidth: "250px",
        height: "auto",
        marginTop: "1vh",
        marginBottom: "1vh",
        borderRadius: 0,
    },
    media: {
        position: 'relative',
        width: "100%",
        height: 0,
        paddingTop: "100%",
    },
    mediaDetails: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        gap: 8,
        background: '#f5f5f5',
        padding: '2px 8px',
    },
    mediaDetail: {
        minWidth: 35,
        textAlign: 'center',
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    title: {
        maxHeight: "4em",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkitLineClamp": 2,
        "-webkitBoxOrient": "vertical"
    },
    toggleButtons: {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        backgroundColor: '#f5f5f5',
    },
    toggleButton: {
        flexGrow: 1,
        borderRadius: 0,
    },
    contentSection: {
        padding: "8px",
    },
}));

export default function PresentableRecipeSmall({
                                                   chipClick,
                                                   recipe,
                                                   commands,
                                                   userClick,
                                                   multiFactor,
                                                   portionChange
                                               }) {
    const classes = useStyles();
    const {recipeName, timeInMinutes, imageData, ingredients, method, about, reqPortions, labels, views} = recipe
    const [showMethod, setShowMethod] = useState(false)

    function formatTime(minutes) {
        if (minutes >= 60) {
            const h = Math.floor(minutes / 60);
            const m = minutes % 60;
            return m > 0 ? `${h}h${m}m` : `${h}h`;
        }
        return `${minutes}m`;
    }

    return (
        <div className={classes.root}>
            <Card variant="outlined" className={classes.card}>
                <CardHeader
                    style={{paddingLeft: 8, paddingTop: 6, paddingBottom: 4}}
                    titleTypographyProps={{variant: "body1", className: classes.title}}
                    title={recipeName ? recipeName.charAt(0).toUpperCase() + recipeName.slice(1).toLowerCase() : ''}
                    action={commands.length > 0 ? <MenuIcon recipe={recipe} commands={commands}/> : null}
                />
                <CardMedia
                    className={classes.media}
                    image={imageData ? imageData : process.env.PUBLIC_URL + "/notFoundImage.svg"}
                    style={imageData ? {} : {backgroundSize: "50%"}}
                    title={recipeName ? recipeName.charAt(0).toUpperCase() + recipeName.slice(1).toLowerCase() : ''}
                >
                    <div className={classes.mediaDetails}>
                        <div className={classes.mediaDetail} style={{marginLeft: -4}}>
                            <Icon color="secondary" style={{overflow: 'visible'}}>
                                <AccessTime/>
                            </Icon>
                            <Typography variant="caption">{formatTime(timeInMinutes)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <Kitchen/>
                            </Icon>
                            <Typography variant="caption">{ingredients.length}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <ChatBubbleOutline/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 50)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <BookmarkBorder/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 100)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <FavoriteBorder/>
                            </Icon>
                            <Typography variant="caption">{Math.floor(Math.random() * 200)}</Typography>
                        </div>
                        <div className={classes.mediaDetail}>
                            <Icon color="secondary">
                                <Visibility/>
                            </Icon>
                            <Typography variant="caption">{views}</Typography>
                        </div>
                    </div>
                </CardMedia>
                <div style={{display: 'flex', alignItems: 'center', padding: '4px 8px 0'}}>
                    <Button onClick={() => userClick(recipe.user.id)} style={{padding: 0, minWidth: 0, textTransform: 'none'}}>
                        <Typography variant="caption" color="textPrimary" component="p">
                            Recipe by: {recipe.user ? recipe.user.username : "N/A"}
                        </Typography>
                    </Button>
                </div>
                {about && (
                    <div style={{padding: '0 8px 4px'}}>
                        <Typography variant="caption" color="textSecondary" component="p">
                            {about}
                        </Typography>
                    </div>
                )}
                {labels && labels.length > 0 && (
                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 4, padding: '0 8px 4px'}}>
                        {labels.map(label => <Chip key={label} label={label} size="small" onClick={() => chipClick(label)} clickable style={{height: 20, fontSize: '0.7rem'}}/>)}
                    </div>
                )}
                <div className={classes.toggleButtons}>
                    <Button className={classes.toggleButton}
                            style={!showMethod ? {backgroundColor: '#34A853', color: '#FFFFFF'} : {backgroundColor: '#f5f5f5', color: '#34A853', border: '1px solid #34A853'}}
                            onClick={() => setShowMethod(false)}>Ingredients</Button>
                    <Button className={classes.toggleButton}
                            style={showMethod ? {backgroundColor: '#34A853', color: '#FFFFFF'} : {backgroundColor: '#f5f5f5', color: '#34A853', border: '1px solid #34A853'}}
                            onClick={() => setShowMethod(true)}>Method</Button>
                </div>

                <CardContent className={classes.contentSection}>
                    {!showMethod && (
                        <div>
                            <div style={{paddingTop: 16, paddingBottom: 16}}>
                                <TextField
                                    id="standard-number"
                                    label="No Portions"
                                    type="number"
                                    defaultValue={reqPortions}
                                    onChange={(x) => portionChange(x.target.value)}
                                    size="small"
                                />
                            </div>
                            {ingredients.map(x => (
                                <div key={x.ingredientId}><Ingredient ingredient={x} multiFactor={multiFactor}/><Divider/></div>
                            ))}
                        </div>
                    )}
                    {showMethod && (
                        <div>
                            {method.split("\n").map((x, idx) =>
                                <Typography key={idx} variant="body1" component="p">
                                    {x}
                                    <br/>
                                </Typography>
                            )}
                        </div>
                    )}
                </CardContent>
            </Card>
        </div>
    )
}
